import MachineNoteType from '../machineNoteType';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Skeleton from '@mui/material/Skeleton';
import Iconify from '../../Iconify';
import { format } from 'date-fns';

const MachineNoteListViewData = ({ note, handleNoteClick, columnWidth }) => {

    const { t } = useTranslation();

    if (!note) {
        return (
            <Box className='table_row'>
                <Box className='tableBodyCell' sx={{ color: '#EA5E00', minWidth: columnWidth.status, position: 'sticky', left: 0, backgroundColor: 'white', zIndex: 1 }}><Skeleton variant="text" width="100%" /></Box>
                <Box sx={{ color: '#414040', minWidth: columnWidth.type }}><Skeleton variant="text" width="100%" /></Box>
                <Box sx={{ color: '#414040', minWidth: columnWidth.created_by }}><Skeleton variant="text" width="100%" /></Box>
                <Box sx={{ color: '#414040', minWidth: columnWidth.email }}><Skeleton variant="text" width="100%" /></Box>
                <Box sx={{ color: '#414040', minWidth: columnWidth.created_at }}><Skeleton variant="text" width="100%" /></Box>
                <Box sx={{ color: '#414040', minWidth: columnWidth.note }}><Skeleton variant="text" width="100%" /></Box>
                <Box sx={{ color: '#EA5E00', width: '50px' }}><Iconify icon={'ri:arrow-right-s-line'} /></Box>
            </Box>
        );
    }

    return (
        <Box className='table_row' onClick={() => handleNoteClick(note)}>
            <Box className='tableBodyCell' sx={{ color: note.status === 'Prise_en_compte' ? '#309129' : note.status === 'Active' ? '#F12525' : 'grey', minWidth: columnWidth.status, maxWidth: columnWidth.status, position: 'sticky', left: 0, backgroundColor: 'white', zIndex: 1 }}>
                <Typography sx={{ fontWeight: note.status === 'Active' ? 700 : 400 }} className='tableBodyTypography'>{t(note?.status)}</Typography>
            </Box>
            <Box className='tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.type, maxWidth: columnWidth.type }}>
                {note?.status === 'Active' ?
                    <MachineNoteType status={note?.type} /> :
                    <Typography className='tableBodyTypography'>{note?.type}</Typography>
                }
            </Box>
            <Box className='tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.created_by, maxWidth: columnWidth.created_by }}>
                <Typography className='tableBodyTypography'>
                    {note?.created_by?.first_name && note?.created_by?.last_name
                        ? `${note?.created_by?.first_name} ${note?.created_by?.last_name}`
                        : note?.anonymous_reporter_name
                            ? note?.anonymous_reporter_name
                            : 'N/A'
                    }
                </Typography>
            </Box>
            <Box className='tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.email, maxWidth: columnWidth.email }}>
                <Typography className='tableBodyTypography'>
                    {note?.created_by?.email
                        ? note?.created_by?.email
                        : note?.anonymous_reporter_email
                            ? note?.anonymous_reporter_email
                            : 'N/A'
                    }
                </Typography>
            </Box>
            <Box className='tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.created_at, maxWidth: columnWidth.created_at }}>
                <Typography className='tableBodyTypography'> {format(new Date(note?.created_at), 'dd/MM/yyyy - HH:mm')}</Typography>
            </Box>
            <Box className='tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.note, maxWidth: columnWidth.note }}>
                <Typography className='tableBodyTypography'>{note?.message}</Typography>
            </Box>
            <Box className='tableBodyCell' sx={{ color: '#EA5E00', minWidth: '50px', maxWidth: '50px' }}><Iconify icon={'ri:arrow-right-s-line'} /></Box>
        </Box>
    );
};

export default MachineNoteListViewData;